import React from 'react';
import moment from 'moment';
import {FormattedNumber} from 'react-intl';

export function formatPercentage(num) {
  if (typeof num === 'number') {
    return <span>{Math.round(num)}%</span>;
  }

  return <span>N/A</span>;
}

export function formatCurrency(num) {
  if (num) {
    num = parseFloat(num);
    num = num.toFixed(2);
  }
  return <FormattedNumber value={num} style={'currency'} currency={'USD'} />;
}

export function formatPercentageArrow(num) {
  if (num === 0) {
    num = num.toFixed(0);
    return <span>{num}%</span>;
  }

  num = num.toFixed(1);
  let arrow = '';

  if (num < 0) {
    arrow = 'spin-chev';
  }

  num = Math.abs(num);

  return <span><i className={'bl bl-up ' + arrow}/>{num}%</span>;
}

export function numberWithCommas(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

export function calcuatePercenatgeDifference(oldValue, newValue) {
  let z;

  if (oldValue > 0) {
    z = ((newValue - oldValue) / oldValue * 100).toFixed(0);
  } else {
    z = 100;
  }

  if (z >= 0) {
    return <span style={{color: 'green'}}>+ {Math.abs(z)} </span>;
  }

  return <span style={{color: 'red'}}>- {Math.abs(z)} </span>;
}


export function getDateLabel(timeframe, previousYear) {
  let output;
  const time = moment();
  const week = time.weeks();
  let year = time.year();

  if (previousYear) {
    year -= 1;
  }
  if (timeframe === 'week') {
    output = <span> Week {week} ({year})</span>;
  } else if (timeframe === 'month') {
    output = <span>{time.format('MMMM')} {year}</span>;
  } else {
    output = <span>{year}</span>;
  }
  return output;
}
